<template>
  <div class="profile-photos info-block">
    <div class="section-header">
      <h2>
        <router-link :to="{ name: 'my-puzzles' }" class="link-inherit">
          {{ $t("profile.puzzles") }}
        </router-link>
        <span v-if="!myPuzzlesIsEmpty('puzzles')" class="count">{{
          count
        }}</span>
      </h2>
      <router-link
        v-if="!myPuzzlesIsEmpty('puzzles')"
        :to="{ name: 'my-puzzles' }"
        class="link"
      >
        <span class="mobile">
          {{ $t("profile.allPuzzles") }}
        </span>
        <div class="mob-not">
          {{ $t("profile.viewAllPuzzles") }}
        </div>
      </router-link>
    </div>
    <div v-if="loader" class="buttons-center">
      <button class="button-loader"></button>
    </div>
    <div v-else-if="!myPuzzlesIsEmpty('puzzles')" class="profile-photos-row">
      <div
        @click="$modal.show('upload-photos', { puzzles: true })"
        class="profile-photos-item profile-photos-item-add"
      >
        <span class="link-blue-underlined">
          {{ $t("profile.add") }}
        </span>
        <span class="link-blue-underlined">
          {{ $t("profile.puzzles") }}
        </span>
      </div>
      <div
        class="profile-photos-item"
        v-for="(puzzle, index) in myPuzzles"
        :key="puzzle.id"
        v-if="index < 5"
        @click="
          $modal.show('photo-details', {
            id: puzzle.id,
            isVideo: false,
          })
        "
      >
        <div
          class="profile-photos-inner puzzle"
          :style="{
            'background-image': puzzle.image ? 'url(' + puzzle.image + ')' : '',
          }"
        ></div>
      </div>
    </div>
    <div
      v-else
      @click="$modal.show('upload-photos', { puzzles: true })"
      class="profile-photos-add"
    >
      <span class="link-blue-underlined">
        {{ $t("profile.addPuzzle") }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProfilePuzzles",
  props: {
    i18n: Object,
  },
  // props: {
  //     id: {
  //         type: [Number, String],
  //         required: true
  //     }
  // },
  data() {
    return {
      loader: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      userIsEmpty: "user/isEmpty",
      myPuzzles: "myPuzzles/fetchMyPuzzles",
      myPuzzlesErrors: "myPuzzles/errors",
      myPuzzlesIsEmpty: "myPuzzles/isEmpty",
      count: "myPuzzles/fetchMyPuzzlesCount",
    }),
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$store
        .dispatch("myPuzzles/get")
        .then(() => {
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_profile-media";
</style>
